export enum C_CHART_TYPE {
  CT1_AREA = 'CT1_AREA',
  CT2_BAR = 'CT2_BAR',
  CT3_COLUMN = 'CT3_COLUMN',
  CT4_LINE = 'CT4_LINE',
  CT5_PIE = 'CT5_PIE',
}
